<template>
    <form v-show="isInputFormActive" method="POST">
        <div class="row">
            <div class="col-lg-4 col-md-4 col-12">
                <div class="form-group">
                    <label for="itemname">
                        {{ localizationStore.translate("credit.bureau") }}
                    </label>
                    <select
                        v-model="selectedCreditBureauId"
                        @change="getCreditBureauList(selectedCreditBureauId)"
                        id="creditbureau"
                        name="creditbureau"
                        class="form-control"
                        :class="{'is-invalid' : creditBureauError}"
                        required
                    >
                        <option v-for="creditBureau in creditBureaus" v-bind:value="creditBureau.id">{{ creditBureau.name }}</option>
                    </select>
                    <span v-if="creditBureauError" class="invalid-feedback" role="alert">
                        <strong>Field is Required</strong>
                    </span>
                </div>
            </div>
            <div class="col-lg-4 col-md-4 col-12">
                <div class="form-group">
                    <label>&nbsp;</label>
                    <br />
                    <button @click="submitForm" type="button" class="btn btn-outline-primary btn-submit"> Dispute Selected Items</button>
                </div>
            </div>
            <div class="col-lg-4 col-md-4 col-12">
                <!-- search input -->
                <div class="custom-search d-flex justify-content-end">
                    <div class="form-group">
                        <label>&nbsp;</label>
                        <div class="d-flex align-items-center">
                            <label class="mr-1">Search</label>
                            <input
                                v-model="searchTerm"
                                placeholder="Search"
                                type="text"
                                class="d-inline-block form-control"
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </form>
    <vue-good-table
      v-show="isInputFormActive"
      ref="student-loan-table"
      v-on:selected-rows-change="creditorSelectionChanged"
      :columns="columns"
      :rows="rows"
      :search-options="{
        enabled: true,
        externalQuery: searchTerm
      }"
      :select-options="{
        enabled: true,
        disableSelectInfo: true,
        selectOnCheckboxOnly: true
      }"
    >
        <template #table-row="props">
            <span v-if="props.column.field === 'action'">
                <div class="d-flex align-items-center col-actions">
                    <a class="mr-1 text-primary" data-toggle="tooltip" data-placement="top" title="Individual Dispute">
                        <vue-feather type="send" @click="dispute(props.row.id)"></vue-feather>
                    </a>
                </div>
            </span>
        </template>
    </vue-good-table>
    <section v-show="!isInputFormActive">
        <div class="row">
            <div class="col-12">
                <div class="card">
                    <div class="card-header p-0 mb-50 mx-auto">
                        <a class="go-back" @click="goBack" >{{ localizationStore.translate("letter.create.back.button.text") }}</a>
                    </div>
                    <div class="card-content">
                        <div class="card-body">
                            <form :action="routes.createLetterRoute" method="post" enctype="multipart/form-data" class="row">
                                <input type="hidden" name="_token" :value="csrf">
                                <input type="text" class="form-control" id="creditbureau" name="creditbureau" :value="selectedCreditBureauId" hidden>
                                <div class="col-md-6 pl-md-0 pr-md-3">
                                    <div id="editor">
                                    </div>
                                    <div class="d-flex justify-content-center my-1">
                                        <button class="btn btn-sm-block btn-primary" type="submit" name="editorType" value="1">
                                            {{ localizationStore.translate("letter.left.submit.button.text") }}
                                        </button>
                                    </div>
                                </div>
                                <div class="col-md-6 pl-md-3 pr-md-0 mt-3 mt-md-0">
                                    <div class="arrow-btn">
                                        <button
                                            class="btn btn-outline-primary px-50"
                                            @click="$refs.spinner.spinLetter()"
                                            type="button"
                                        >
                                            {{ localizationStore.translate("spin.letter.button.text") }}
                                            <i data-feather="arrow-right"></i>
                                        </button>
                                    </div>
                                    <div id="editor-right">
                                    </div>
                                    <div class="d-flex justify-content-center my-1">
                                        <button class="btn btn-sm-block btn-primary" type="submit" name="editorType" value="2">
                                            {{ localizationStore.translate("letter.right.submit.button.text") }}
                                        </button>
                                    </div>
                                </div>
                                <spinner ref="spinner" :user-info='userInfo' :editor-ref='editorRefSingle' />
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div ref="editorRefSingle" hidden>
            <p>
                {{ userInfo.firstname }} {{ userInfo.lastname }}
                <br />
                {{ userInfo.address }}
                <br />
                {{ userInfo.city }}, {{ userInfo.state }} {{ userInfo.zipcode }}
                <br />
                {{ userInfo.ssn }}
                <br />
                <br />
                {{ selectedCreditBureau.address_name }}
                <br />
                {{ selectedCreditBureau.street_address }}
                <br />
                {{ selectedCreditBureau.city }}, {{ selectedCreditBureau.state_abbrev }} {{ selectedCreditBureau.zipcode }}
                <br />
                <br />
                Date: {{ date }}
            </p>
            <div class="page">
                <p>
                    <strong>
                        To: {{ selectedCreditBureau.address_name }}
                    </strong>
                </p>
                <p class="letter-content">
                    I've recently received my consumer report and noticed that it is inaccurate and unfair to me as a
                    consumer meaning it brings me no value and is not equitable to me as the consumer.
                </p>
                <p class="letter-content">
                    I've noticed that you are reporting a bankruptcy on my report. That is a clear violation of my right to privacy
                according to the FCRA <strong>15 USC 1681(a)(4)</strong>, where it states it is your grave responsibility to respect my
                right to privacy.
                </p>
                <p class="letter-content">
                    I've contacted the bankruptcy court and they have notified me that they don't report
                    to any reporting agency. In addition I never gave consent nor do I have any written contract or
                    agreement for you to furnish any thing on my credit report according to <strong>15 USC 1681b (a)(2)</strong>. I never
                    gave you written instructions to furnish anything. Again this a violation of the FCRA.
                </p>

                <p class="letter-content">
                    I am writing and now giving written instructions for you to remove the following accounts from my credit report for it is in
                    clear violation of my right to privacy.
                </p>

                <p class="letter-content" v-if="selectedCreditor.length > 0">
                    The following bankruptcy item(s) that you prepared and published about me is inaccurate and incomplete:
                    <br />
                    <br />
                    <strong>{{ selectedCreditor[0].furnisher_name }}</strong> -
                    <strong>{{ selectedCreditor[0].account_number }}</strong>
                    <br />
                    Please remove this inaccurate account from my credit file.
                </p>
                <p class="letter-content">
                    Since it appears that you do not have reasonable procedures in place to
                    assure maximum accuracy and/or completeness of the information
                    in your consumer reports concerning me, I request that any future reporting about me must be sent to me first for my
                    review
                    before you prepare and publish any information in a consumer report concerning me directly or inderictly.
                    <br>
                    <br>
                    Enclosed are copies of ID and proof of mailing address.
                </p>
                <p style="page-break-after: always;" class="letter-content">
                    Regards, <br /> <br />
                    {{ userInfo.firstname }} {{ userInfo.lastname }}
                </p>
            </div>
            <div class="page-content">
                <h1 style="padding: 0rem; 3rem; text-align: center;">Enclosures</h1>
                <p style="padding-top:3rem; text-align: center;">
                    <img v-if='userInfo.ssn_image_url' v-bind:src='userInfo.ssn_image_url' width='300' height='200' />
                    <img v-if='userInfo.identity_image_url' v-bind:src='userInfo.identity_image_url' width='300' height='200' />
                </p>
                <p v-if='userInfo.address_verify_image_url'>
                    <img v-bind:src='userInfo.address_verify_image_url' width='300' height='200' />
                </p>
            </div>
        </div>
        <div ref="editorRefMultiple" hidden>
            <p>
                {{ userInfo.firstname }} {{ userInfo.lastname }}
                <br />
                {{ userInfo.address }}
                <br />
                {{ userInfo.city }}, {{ userInfo.state }} {{ userInfo.zipcode }}
                <br />
                {{ userInfo.ssn }}
                <br />
                <br />
                {{ selectedCreditBureau.address_name }}
                <br />
                {{ selectedCreditBureau.street_address }}
                <br />
                {{ selectedCreditBureau.city }}, {{ selectedCreditBureau.state_abbrev }} {{ selectedCreditBureau.zipcode }}
                <br />
                <br />
                Date: {{ date }}
            </p>
            <div class="page">
                <p>
                    <strong>
                        To: {{ selectedCreditBureau.address_name }}
                    </strong>
                </p>
                <p class="letter-content">
                    I've recently received my consumer report and noticed that it is inaccurate and unfair to me as a
                    consumer meaning it brings me no value and is not equitable to me as the consumer.
                </p>
                <p class="letter-content">
                    I've noticed that you are reporting a bankruptcy on my report. That is a clear violation of my right to privacy
                according to the FCRA <strong>15 USC 1681(a)(4)</strong>, where it states it is your grave responsibility to respect my
                right to privacy.
                </p>
                <p class="letter-content">
                    I've contacted the bankruptcy court and they have notified me that they don't report
                    to any reporting agency. In addition I never gave consent nor do I have any written contract or
                    agreement for you to furnish any thing on my credit report according to <strong>15 USC 1681b (a)(2)</strong>. I never
                    gave you written instructions to furnish anything. Again this a violation of the FCRA.
                </p>

                <p class="letter-content">
                    I am writing and now giving written instructions for you to remove the following accounts from my credit report for it is in
                    clear violation of my right to privacy.
                </p>

                <p class="letter-content" v-if="selectedCreditor.length > 0">
                    <template v-for="creditor in selectedCreditor">
                        The following bankruptcy item(s) that you prepared and published about me is inaccurate and incomplete:
                        <br />
                        <br />
                        <strong>{{ creditor.furnisher_name }}</strong> -
                        <strong>{{ creditor.account_number }}</strong>
                        <br />
                        Please remove this inaccurate account from my credit file.
                    </template>
                </p>
                <p class="letter-content">
                    Since it appears that you do not have reasonable procedures in place to
                    assure maximum accuracy and/or completeness of the information
                    in your consumer reports concerning me, I request that any future reporting about me must be sent to me first for my
                    review
                    before you prepare and publish any information in a consumer report concerning me directly or inderictly.
                    <br>
                    <br>
                    Enclosed are copies of ID and proof of mailing address.
                </p>
                <p style="page-break-after: always;" class="letter-content">
                    Regards, <br /> <br />
                    {{ userInfo.firstname }} {{ userInfo.lastname }}
                </p>
            </div>
            <div class="page-content">
                <h1 style="padding: 0rem; 3rem; text-align: center;">Enclosures</h1>
                <p style="padding-top:3rem; text-align: center;">
                    <img v-if='userInfo.ssn_image_url' v-bind:src='userInfo.ssn_image_url' width='300' height='200' />
                    <img v-if='userInfo.identity_image_url' v-bind:src='userInfo.identity_image_url' width='300' height='200' />
                </p>
                <p v-if='userInfo.address_verify_image_url'>
                    <img v-bind:src='userInfo.address_verify_image_url' width='300' height='200' />
                </p>
            </div>
        </div>
    </section>
</template>
<script>
  import { reactive, computed, ref } from 'vue'
  import 'vue-good-table-next/dist/vue-good-table-next.css'
  import { VueGoodTable } from 'vue-good-table-next';
  import { useLocalizationStore } from '../../stores/LocalizationStore.js'
  export default {
    props: {
        csrf: {
            type: String
        },
        creditBureaus: {
            type: [Array, Object]
        },
        userInfo: {
            type: [Array, Object]
        },
    },
    components: {
        VueGoodTable,
    },
    setup(props) {
        return {
            selectedCreditBureauId: ref(props.creditBureaus[0].id),
            editorRefSingle: ref(null),
            editorRefMultiple: ref(null),
            isInputFormActive: ref(true),
            creditBureauError: ref(false),
            date: ref(null),
            localizationStore: useLocalizationStore()
        };
    },
    data(){
        const selectedCreditor = reactive([]);
        return {
          columns: [
            {
              label: 'CREDITOR',
              field: 'furnisher_name',
            },
            {
              label: 'ACCOUNT NUMBER',
              field: 'account_number',
            },
            {
              label: 'PAYMENT STATUS',
              field: 'payment_status',
            },
            {
              label: 'Action',
              field: 'action',
            }
          ],
          rows: [],
          searchTerm: '',
          selectedCreditor
        };
    },
    created() {
        // console.log(this.creditBureaus);
    },
    mounted() {
        axios.get(this.routes.currentDate).then(response => (this.date = response.data));
        this.getCreditBureauList(this.selectedCreditBureauId);
    },
    computed: {
        // a computed getter
        selectedCreditBureau() {
            return this.creditBureaus.find((attribute) => {
                if (attribute.id == this.selectedCreditBureauId) {
                    return attribute;
                }
            })
        },
        isCreditBureauSelected() {
            return (this.selectedCreditBureauId == null || this.selectedCreditBureauId == "null") ? false : true;
        }
    },
    methods: {
      dispute: function (id) {
        this.selectedCreditor[0] = this.rows.find((attribute) => {
            if (attribute.id == id) {
                return attribute;
            }
        });
        setTimeout(() => {
            tinymce.get('editor').setContent(this.editorRefSingle.innerHTML);
            this.isInputFormActive = !this.isInputFormActive;
        }, "100");
      },
      submitForm: function () {
        if (this.validate()) {
            this.editorRef = this.editorRefMultiple;
            this.selectedCreditor = this.$refs['student-loan-table'].selectedRows;
            tinymce.get('editor').setContent(this.editorRefMultiple.innerHTML);
            this.isInputFormActive = !this.isInputFormActive;
        }
      },
      goBack: function () {
        this.isInputFormActive = !this.isInputFormActive;
      },
      validate: function () {
        if (this.selectedCreditBureauId == null || this.selectedCreditBureauId == "null") {
            this.creditBureauError = true;
        }
        else {
            this.creditBureauError = false;
        }
        return !this.creditBureauError;
      },
      getCreditBureauList: function (type) {
        axios.get(this.routes.listCreditBureau.replace(':type', type)).then(response => {
                this.rows = response.data.data
            }
        );
      },
      creditorSelectionChanged: function (params) {
        this.selectedCreditor = params.selectedRows;
      }
    }
  };
</script>
